import moment from "moment";

const esc = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const text = (value) =>
  value === null || value === undefined || value === "" ? "—" : value;

const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD-MMM-YYYY HH:mm") : String(value);
};

const pairRows = (pairs) =>
  pairs
    .map(
      ([label, value]) =>
        `<tr>
          <td style="width:22%;padding:6px 8px;border:1px solid #d9d9d9;background:#fafafa;font-weight:600;">${esc(label)}</td>
          <td style="width:28%;padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(value))}</td>
        </tr>`,
    )
    .join("");

const section = (title, body) => `
  <h3 style="margin:18px 0 8px;font-size:14px;">${esc(title)}</h3>
  ${body}
`;

export const buildImportShipmentHtml = (record) => {
  const details = record?.import_vehicle_details || [];
  const vehicles = record?.transport_vehicles || [];
  const charges = record?.transport_charges || [];

  const ctg = [
    ["Vehicle Number", record?.vehicle_number],
    ["Transporter", record?.transporter],
    ["Vehicle Size", record?.vehicle_size],
    ["Vehicle Type", record?.vehicle_type],
    ["Vehicle Quantity", record?.vehicle_qty],
    ["Empty Vehicle Arrival Time", formatDateTime(record?.empty_vehicle_arrival_time)],
    ["Driver Name", record?.driver_name],
    ["Driver Cell No.", record?.driver_cell_number],
    ["Driving License Number", record?.driving_license_number],
    ["Place of Loading", record?.loading_place],
    ["Dispatch Date Time", formatDateTime(record?.dispatch_time)],
    ["Challan No", record?.challan_info?.challan_no],
    ["Security Bolt Seal No", record?.security_bolt_seal_number],
    ["Place of Arrival", record?.delivery_place],
    ["Importer Name", record?.importer_name],
  ];

  const factory = [
    ["Arrival Date & Time", formatDateTime(record?.arrival_date)],
    ["Unloading Date Time", formatDateTime(record?.unloading_date)],
  ];

  const consignmentRows = details.length
    ? details
        .map((item) => {
          const salesContract =
            item?.sales_contract_info?.reference_no ||
            item?.invoice_info?.sale_contract_info?.reference_no ||
            item?.invoice_info?.sales_contract_number ||
            "—";
          return `<tr>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.type_of_shipment))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(salesContract)}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.b2b_lc_info?.b2b_lc_number))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.invoice_info?.invoice_number))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.invoice_info?.quantity_ctn))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.invoice_info?.cbm))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.invoice_info?.gross_weight))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.loading_qty))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.loading_cbm))}</td>
          </tr>`;
        })
        .join("")
    : `<tr><td colspan="9" style="padding:6px 8px;border:1px solid #d9d9d9;">No consignment details</td></tr>`;

  const vehicleRows = vehicles.length
    ? vehicles
        .map(
          (item) => `<tr>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.particular?.particular))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.charge_amount))}</td>
          </tr>`,
        )
        .join("")
    : `<tr><td colspan="2" style="padding:6px 8px;border:1px solid #d9d9d9;">No transporter details</td></tr>`;

  const chargeRows = charges.length
    ? charges
        .map(
          (item) => `<tr>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.charge_type?.name))}</td>
            <td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(item?.amount))}</td>
          </tr>`,
        )
        .join("")
    : `<tr><td colspan="2" style="padding:6px 8px;border:1px solid #d9d9d9;">No other charges</td></tr>`;

  return `
    <div style="font-family:Arial,sans-serif;color:#111;padding:16px;">
      <h2 style="text-align:center;margin:0 0 4px;">Import Shipment for Single Vehicle</h2>
      <p style="text-align:center;margin:0 0 16px;">${esc(record?.importer_name || "")}</p>
      ${section(
        "CTG Part",
        `<table style="width:100%;border-collapse:collapse;font-size:12px;">${pairRows(ctg)}</table>`,
      )}
      ${section(
        "Factory",
        `<table style="width:100%;border-collapse:collapse;font-size:12px;">${pairRows(factory)}</table>`,
      )}
      ${section(
        "Consignment Details",
        `<table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr>
              ${[
                "Type of Shipment",
                "Sales Contract",
                "LC No.",
                "Invoice No.",
                "Import Qty.",
                "CBM",
                "Gross Weight",
                "Loading Qty.",
                "Loading CBM",
              ]
                .map(
                  (heading) =>
                    `<th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">${heading}</th>`,
                )
                .join("")}
            </tr>
          </thead>
          <tbody>${consignmentRows}</tbody>
        </table>`,
      )}
      ${section(
        "Transporter Details",
        `<table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr>
              <th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">Particular</th>
              <th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">Charge Amount</th>
            </tr>
          </thead>
          <tbody>${vehicleRows}</tbody>
        </table>`,
      )}
      ${section(
        "Other Charges",
        `<table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr>
              <th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">Charge Type</th>
              <th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">Amount</th>
            </tr>
          </thead>
          <tbody>${chargeRows}</tbody>
        </table>`,
      )}
      <table style="width:100%;margin-top:56px;font-size:12px;">
        <tr>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;">${esc(record?.creator?.name || "")}</div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Applicant</div>
          </td>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;"></div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Checked by</div>
          </td>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;"></div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Approved by</div>
          </td>
        </tr>
      </table>
    </div>
  `;
};

export const downloadImportShipment = (record) => {
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8" /><title>Import Shipment for Single Vehicle</title></head><body>${buildImportShipmentHtml(
    record,
  )}</body></html>`;
  const blob = new Blob([html], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `import-single-vehicle-${record?.vehicle_number || record?.id || "shipment"}.xls`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const ImportShipmentPrint = ({ record }) => (
  <div dangerouslySetInnerHTML={{ __html: buildImportShipmentHtml(record) }} />
);

export default ImportShipmentPrint;
